import {
  Location,
  NavigateFunction,
  NavigateOptions,
  To,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  searchParamsToState,
  stateToSearchParams,
} from "../../utils/querystring";
import { useCallback } from "react";

export const useNavigateWithSearchState = () => {
  const location = useLocation();
  const [currentSearch] = useSearchParams();
  const navigate = useNavigate();

  const fn: NavigateFunction = useCallback(
    (delta: To | number, options?: NavigateOptions) => {
      if (typeof delta === "number") {
        return navigate(delta);
      }

      navigate(getToParam(delta, location), {
        ...options,
        state: {
          ...options?.state,
          previousSearch: searchParamsToState(currentSearch),
        },
      });
    },
    [currentSearch, location, navigate]
  );

  return fn;
};

export function getToParam(delta: To, location: Location) {
  const search = stateToSearchParams(location.state?.previousSearch).toString();

  const to =
    typeof delta === "string"
      ? {
          pathname: delta,
          search,
        }
      : { ...delta, search };

  return to;
}
